<script setup>
</script>
<template>
    <div class="pagination"></div>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.pagination {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 1rem;
}
:deep(.swiper-pagination-bullet) {
    border-radius: 5rem;
    width: 1rem;
    height: 1rem;
    opacity: .24;
    background: var(--fill-accent-2-1);
}
:deep(.swiper-pagination-bullet-active) {
    width: 3rem;
    height: 1rem;
    background: var(--fill-accent-2-1);
    opacity: 1;
}
</style>